import React from 'react';
import styled from 'styled-components';

interface CheckboxProps {
    checked: boolean;
    // eslint-disable-next-line react/require-default-props
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    text: string;
    id: string;
}

const Label = styled.label`
    display: flex;
    justify-content: center;
    margin: 8px;
`;

const Input = styled.input`
    margin-right: 8px;
`;

const Checkbox = ({ checked, onChange, id, text }: CheckboxProps) => {
    return (
        <Label htmlFor={id}>
            <Input type="checkbox" checked={checked} onChange={onChange} id={id} />
            {text}
        </Label>
    );
};

export default Checkbox;
